let promoSwiper = null;
let logoSwiper = null;
let promoCardSwiper = null;
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  setTimeout(() => {
  init();
}, 300);
}


function init() {
  // Init on load
initStickyHeader();
initpromoSwiperTop();
initslideShow();
initGuarantee();
initProductCarousel();
initArticleProductCarousel();
initPromoSwiper();
initLogoSwiper();
initPromoCardSwiper();
initTestimonial();
initRecentBlog();
initNewsLetter();
initSubCategoryCTA();
initProductMessages();
document.querySelector('.custom__search-input')?.blur();
/*-- Disable qty when 1 --*/
function initQuantitySelectors() {
    document.querySelectorAll('.quantity-selector').forEach(function (container) {

      const input = container.querySelector("input[type='number']");
      const minusBtn = container.querySelector('.quantity-minus');
      const plusBtn = container.querySelector('.quantity-plus');

      if (!input || !minusBtn) return;

      const minQty = parseInt(input.getAttribute('min')) || 1;

      function toggleMinusButton() {
        const currentQty = parseInt(input.value) || minQty;

        if (currentQty <= minQty) {
          minusBtn.disabled = true;
          minusBtn.setAttribute('aria-disabled', 'true');
        } else {
          minusBtn.disabled = false;
          minusBtn.setAttribute('aria-disabled', 'false');
        }
      }

      // Run once
      toggleMinusButton();

      // Input typing
      input.addEventListener('input', toggleMinusButton);
      input.addEventListener('change', toggleMinusButton);

      // Buttons click (important: delay AFTER value updates)
      container.addEventListener('click', function (e) {
        if (e.target.closest('.quantity-minus, .quantity-plus')) {
          setTimeout(toggleMinusButton, 100);
        }
      });

    });
  }

  // Init on load
  initQuantitySelectors();

  // 🔥 Shopify section reload fix (VERY IMPORTANT)
  document.addEventListener('shopify:section:load', initQuantitySelectors);
// setTimeout(() => {
//     const firstTab = document.querySelector('.r-tabs-anchor[href="#product_details"]');
//     if (firstTab) firstTab.click();
//   }, 100);
document.querySelectorAll('.product-shortDescription .scrollToSection')
  .forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
       const tabLink = document.querySelector('.r-tabs-anchor[href="#product_details"]');
      if (tabLink) tabLink.click();
      setTimeout(() => {
        const targetId = this.getAttribute('href');

      const scrollToTarget = () => {
        const targetEl = document.querySelector(targetId);

        if (targetEl) {
          const header = document.querySelector('.header-section .header');
          const offset = header ? header.getBoundingClientRect().height : 0;
          
          const top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset * 2;

          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      };

      scrollToTarget();
      }, 200);

      
    });
  });
}


function initStickyHeader(){
    /*--- [ Sticky Header ] ---*/
const header = document.querySelector(".header-section");
const bodyEle = document.body;

const popup = document.querySelector('.usf-popup');
const search_input = document.querySelector('.custom__search-input')
let fold = document.querySelector("#header-group").offsetHeight + 30;//window.innerHeight;
if (window.innerWidth < 767) {
  fold = 200;
} else {
  fold = document.querySelector("#header-group").offsetHeight + 30;//window.innerHeight;
}
let isFixed = false;
window.addEventListener("scroll", function () {
  const headerHeight = header.offsetHeight;
  if (window.scrollY > fold) {
    if (!isFixed) {
      document.body.style.paddingTop = headerHeight + "px";
      header.classList.add("fixed", "slide-down");
      header.classList.remove("slide-up");
      bodyEle.classList.add("is-sticky-header");

      
      isFixed = true;
    }
  } else {
    if (isFixed) {
      header.classList.remove("slide-down");
      header.classList.add("slide-up");

      // wait for animation to finish before removing fixed
      header.addEventListener("animationend", function handler() {
        document.body.style.paddingTop = "0";
        header.classList.remove("fixed", "slide-up");
        bodyEle.classList.remove("is-sticky-header");
        const observer = new MutationObserver(() => {
        const popup = document.querySelector('.usf-popup');
        const input = document.querySelector('.header-top .custom__search-input');

          if (popup && input && !popup.classList.contains('usf-hide')) {
            input.focus();
            input.click();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true
        });
        header.removeEventListener("animationend", handler);
      });

      isFixed = false;
    }
  }
});
// ✅ update fold on resize (NOT re-init)
  window.addEventListener("resize", function () {
    if (window.innerWidth < 767) {
      fold = 200;
    } else {
      fold = window.innerHeight;
    }
  });
}
function initpromoSwiperTop() {
  // $('.promo-banner .slider-wrapper').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: true, // ✅ loop
  //   autoplay: true,
  //   autoplaySpeed: 4000,
  //   speed: 500,
  //   fade: true, // ✅ fade effect
  //   cssEase: 'linear',
  //   arrows: true,
  //   prevArrow: $('.promo-banner .swiper-button-prev'),
  //   nextArrow: $('.promo-banner .swiper-button-next'),
  // });
  const promoSwiperTop = new Swiper('.promo-banner', {
      // loop: true,
      slidesPerView: 2,
      effect: "fade",
      speed: 500,
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4000,
      },
      navigation: {
          nextEl: '.promo-banner .swiper-button-next',
          prevEl: '.promo-banner .swiper-button-prev',
      },
    });
}
function initslideShow() {
const swiper = new Swiper('.slideshow__slider', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.slideshow__slider .swiper-pagination',
        clickable: true,
      },
      navigation: {
          nextEl: '.slideshow__slider .swiper-button-next',
          prevEl: '.slideshow__slider .swiper-button-prev',
      },
    });
}
function initGuarantee() {
  // Guarantee Slider initialize
    const slider = document.querySelector('.guarantee-slider_wrapper');
    if (!slider) return;
    const slides = slider.querySelectorAll('.guarantee-slider-list > .shopify-block');

    if (slides.length === 0) return;
    slides.forEach((slide) => {
        slide.classList.add('swiper-slide');
    });

    
    if (typeof Swiper !== 'undefined') {
        setTimeout(() => {
            
        const guaranteeSwiper = new Swiper('.guarantee-slider_wrapper', {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.guarantee-slider_wrapper .swiper-button-next',
            prevEl: '.guarantee-slider_wrapper .swiper-button-prev',
        },
        });
        }, 300);
    }
}
function initProductCarousel(){
  // Product Slider initialize
      const productSlider = document.querySelector('.products-carousel-list');
      if (!productSlider) return;

      
      const productSwiper = new Swiper('.products-carousel-list', {
          slidesPerView: 2,
          loop: false,
          navigation: {
              nextEl: '.products-carousel-list .swiper-button-next',
              prevEl: '.products-carousel-list .swiper-button-prev',
          },
          scrollbar: {
            el: '.products-carousel-list .swiper-scrollbar',
            hide: false,
            draggable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
            1281: {
              slidesPerView: 4,
            },
          },
      });
}
function initArticleProductCarousel(){
  // Product Slider initialize
      const articleProductSlider = document.querySelector('.article-products-carousel-list');
      if (!articleProductSlider) return;

      
      const articleProductSwiper = new Swiper('.article-products-carousel-list', {
          slidesPerView: 2,
          loop: false,
          navigation: {
              nextEl: '.article-products-carousel-list .swiper-button-next',
              prevEl: '.article-products-carousel-list .swiper-button-prev',
          },
          scrollbar: {
            el: '.article-products-carousel-list .swiper-scrollbar',
            hide: false,
            draggable: true,
          },
          breakpoints: {
            640: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 3,
            },
            1281: {
              slidesPerView: 3,
            },
          },
      });
}
function initPromoSwiper() {
  if (window.innerWidth <= 1023 && !promoSwiper) {
    promoSwiper = new Swiper('.promotion-grid-list', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: '.promotion-grid-list .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
          640: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
        },
    });
  } else if (window.innerWidth > 1023 && promoSwiper) {
    promoSwiper.destroy(true, true);
    promoSwiper = null;
  }
}

function initLogoSwiper() {
  if (window.innerWidth <= 1023 && !logoSwiper) {
    logoSwiper = new Swiper('.icons-list', {
      slidesPerView: 3,
      loop: false,
      scrollbar: {
          el: '.icons-list .swiper-scrollbar',
          hide: false,
          draggable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 5,
          },
        },
    });
  } else if (window.innerWidth > 1023 && logoSwiper) {
    logoSwiper.destroy(true, true);
    logoSwiper = null;
  }
}

function initPromoCardSwiper() {
  if (window.innerWidth <= 1023 && !promoCardSwiper) {
    promoCardSwiper = new Swiper('.multicolumn-list__wrapper', {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: '.multicolumn-list__wrapper .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
    });
  } else if (window.innerWidth > 1023 && promoCardSwiper) {
    promoCardSwiper.destroy(true, true);
    promoCardSwiper = null;
  }
}

function initTestimonial(){
  // Testimonail Slider initialize
    const testimonialsSlider = document.querySelector('.testimonials');
    if (!testimonialsSlider) return;
    // $('.testimonials-list').slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   infinite: true, // ✅ loop
    //   autoplay: true,
    //   autoplaySpeed: 6000,
    //   speed: 500, // transition speed
    //   fade: true, // ✅ equivalent to effect: "fade"
    //   cssEase: 'linear', // smooth fade
    //   arrows: false, // add if needed
    //   dots: false // add if needed
    // });
    
    const testimonialsSwiper = new Swiper('.testimonials', {
        slidesPerView: 1,
        loop: true,
        loopedSlides: 1,
        effect: "fade",
        speed: 500,
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        watchSlidesProgress: true,
        virtualTranslate: true,
        });
        // Parralex image
        const bg = document.querySelector('.background-image img');

        if (!bg) return;

        let ticking = false;

        function updateParallax() {
          const rect = bg.getBoundingClientRect();
          const scrollPercent = rect.top / window.innerHeight;

          // 👇 subtle movement (adjust 20 → lower = more subtle)
          const translateY = scrollPercent * 40;

          bg.style.transform = `scale(1.01) translateY(${-translateY}px)`;
          ticking = false;
        }

        function onScroll() {
          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }
        }

        window.addEventListener('scroll', onScroll);
}
function initRecentBlog(){
  // Resource Blog Slider initialize
        const BlogSlider = document.querySelector('.resource-slider');
        if (!BlogSlider) return;

        
        const blogSwiper = new Swiper('.resource-slider', {
            slidesPerView: 1.56,
            loop: false,
            navigation: {
                nextEl: '.resource-slider .swiper-button-next',
                prevEl: '.resource-slider .swiper-button-prev',
            },
            scrollbar: {
              el: '.resource-slider .swiper-scrollbar',
              hide: false,
              draggable: true,
            },
            breakpoints: {
              640: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1281: {
                slidesPerView: 4,
              },
            },
        });
}

function initNewsLetter(){
   // Newsletter Promo Slider initialize
        const NewsPromoSlider = document.querySelector('.newsletter_promo_list');
        if (!NewsPromoSlider) return;

        // $('.newsletter_promo_list .slider-wrapper').slick({
        //   slidesToShow: 1,
        //   slidesToScroll: 1,
        //   infinite: true, // ✅ loop
        //   autoplay: true,
        //   autoplaySpeed: 6000,
        //   speed: 400,
        //   fade: true, // ✅ fade effect
        //   cssEase: 'linear',
        //   arrows: true,
        //   prevArrow: $('.newsletter_promo_list .swiper-button-prev'),
        //   nextArrow: $('.newsletter_promo_list .swiper-button-next'),
        // });
        const newsPromoSwiper = new Swiper('.newsletter_promo_list', {
            loop: true,
            loopedSlides: 1,
            slidesPerView: 1,
            effect: "fade",
            speed: 800,
            fadeEffect: {
              crossFade: true
            },
            autoplay: {
              delay: 6000,
              disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.newsletter_promo_list .swiper-button-next',
                prevEl: '.newsletter_promo_list .swiper-button-prev',
            },
            watchSlidesProgress: true,
            virtualTranslate: true,
        });
}
function initSubCategoryCTA(){
  // Product Slider initialize
        const subcategoriesSlider = document.querySelector('.subcategory-cta');
        if (!subcategoriesSlider) return;
        
        // @ts-ignore
        const subcategoriesSwiper = new Swiper('.subcategory-cta', {
            slidesPerView: 'auto',
            loop: false,
            navigation: {
                nextEl: '.subcategories-inner .swiper-button-next',
                prevEl: '.subcategories-inner .swiper-button-prev',
            },
            breakpoints: {
              640: {
                slidesPerView: 'auto',
              },
              1024: {
                slidesPerView: 'auto',
              },
              1281: {
                slidesPerView: 6,
              },
            },
        });
}
function initProductMessages() {
   const ProductMessagesSlider = document.querySelector('.product-messages-swiper');
    if (!ProductMessagesSlider) return;
    const ProductMessagesSwiper = new Swiper('.product-messages-swiper', {
      loop: true,
      slidesPerView: 1,
      navigation: {
          nextEl: '.product-messages-swiper .swiper-button-next',
          prevEl: '.product-messages-swiper .swiper-button-prev',
      },
      });
}
// Re-check on resize
window.addEventListener('resize', () => {
  initStickyHeader();
  initpromoSwiperTop();
  initslideShow();
  initGuarantee();
  initProductCarousel();
  initPromoSwiper();
  initLogoSwiper();
  initPromoCardSwiper();
  initTestimonial();
  initRecentBlog();
  initNewsLetter();
  initSubCategoryCTA();
  initProductMessages();
});

